import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/UserContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Exams from './pages/Exams';
import ExamDetail from './pages/ExamDetail';
import Users from './pages/Users';
import Sites from './pages/Sites';
import Stations from './pages/Stations';
import SiteSearch from './pages/SiteSearch';
import PublicExamsSearch from './pages/PublicExamsSearch';
import Patients from './pages/Patients';
import Reports from './pages/Reports';
import SyncJobs from './pages/SyncJobs';
import PayloadGenerator from './pages/PayloadGenerator';
import PacsResultImport from './pages/PacsResultImport';
import AppLayout from './layouts/AppLayout';
import MyProfile from './pages/MyProfile';
import MySecurity from './pages/MySecurity';
import PrivateRoute from './components/PrivateRoute';
import RequireRole from './components/permissions/RequireRole';
import RequireGlobalAccess from './components/permissions/RequireGlobalAccess';
import RequireSiteScope from './components/permissions/RequireSiteScope';
import RequireMenuAccess from './components/permissions/RequireMenuAccess';
import MonitoringPage from './pages/MonitoringPage';
import AuditLogs from './pages/AuditLogs';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/public/exams-search" element={<PublicExamsSearch />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <RequireMenuAccess>
                <AppLayout />
              </RequireMenuAccess>
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />

          <Route path="dashboard" element={<RequireSiteScope><Dashboard /></RequireSiteScope>} />
          <Route path="report" element={<RequireSiteScope><Reports /></RequireSiteScope>} />

          <Route path="exams" element={<RequireSiteScope><Exams /></RequireSiteScope>} />
          <Route path="exams/:id" element={<RequireSiteScope><ExamDetail /></RequireSiteScope>} />

          <Route path="patients" element={<RequireSiteScope><Patients /></RequireSiteScope>} />
          <Route path="site-search" element={<RequireSiteScope><SiteSearch /></RequireSiteScope>} />
          <Route path="site/search" element={<Navigate to="/site-search" replace />} />

          <Route path="sites" element={<RequireGlobalAccess><Sites /></RequireGlobalAccess>} />
          <Route
            path="users"
            element={
              <RequireRole roles={['SuperAdmin', 'CloudAdmin']}>
                <Users />
              </RequireRole>
            }
          />
          <Route
            path="sync-jobs"
            element={
              <RequireRole roles={['SuperAdmin', 'CloudAdmin']}>
                <SyncJobs />
              </RequireRole>
            }
          />
          <Route
            path="payload-generator"
            element={
              <RequireRole roles={['SuperAdmin', 'CloudAdmin']}>
                <PayloadGenerator />
              </RequireRole>
            }
          />
          <Route
            path="pacs-result-import"
            element={
              <RequireRole roles={['SuperAdmin', 'LocalAPI']}>
                <PacsResultImport />
              </RequireRole>
            }
          />

          <Route path="monitoring" element={<RequireRole roles={['SuperAdmin', 'CloudAdmin', 'LocalUser']}><MonitoringPage /></RequireRole>} />
          <Route path="audit-logs" element={<RequireRole roles={['SuperAdmin']}><AuditLogs /></RequireRole>} />

          <Route path="me/profile" element={<MyProfile />} />
          <Route path="me/security" element={<MySecurity />} />
          <Route path="403" element={<Forbidden />} />

          <Route path="stations" element={<RequireSiteScope><Stations /></RequireSiteScope>} />
          <Route path="dashboard/system" element={<Navigate to="/report" replace />} />
          <Route path="reports" element={<Navigate to="/report" replace />} />
          <Route path="stats" element={<Navigate to="/report" replace />} />
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="gpacs-toast"
        bodyClassName="gpacs-toast-body"
        progressClassName="gpacs-toast-progress"
      />
    </AuthProvider>
  );
}

export default App;
